import { HttpClient, HttpErrorResponse, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BehaviorSubject, Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';




export enum FileQueueStatus {
    Init,
    Pending,
    Success,
    Error,
    Progress,
    Cancel
}

export class FileQueueObject {

    public file: any;
    public id = 0;
    public status: FileQueueStatus = FileQueueStatus.Init;
    public progress = 0;
    public request_subscription: Subscription = null;
    public response: HttpResponse<any> | HttpErrorResponse = null;
    public request: HttpRequest<any> = null;
    constructor(file: any) {
        this.file = file;
    }

    // actions
    public download = () => { /* set in service */ };
    public cancel = () => { /* set in service */ };
    public remove = () => { /* set in service */ };
    public delete = () => { /* set in service */ };

    // statuses
    public inInit = () => this.status === FileQueueStatus.Init;
    public isCancel = () => this.status === FileQueueStatus.Cancel;
    public isPending = () => this.status === FileQueueStatus.Pending;
    public isSuccess = () => this.status === FileQueueStatus.Success;
    public isError = () => this.status === FileQueueStatus.Error;
    public inProgress = () => this.status === FileQueueStatus.Progress;
    public isCheckToDownload = () => this.status === FileQueueStatus.Pending || this.status === FileQueueStatus.Error;
}

@Injectable()
export class FileDownloaderService {
    PATH_DOWNLOAD = environment.API_BASE + '/files';
    PATH_DELETE = environment.API_BASE + '/Informes'; // /Informes/{IdInforme}
    private _queue: BehaviorSubject<FileQueueObject[]>;
    private _files: FileQueueObject[] = [];
    private req;

    constructor(private http: HttpClient) {
        this._queue = <BehaviorSubject<FileQueueObject[]>>new BehaviorSubject(this._files);
    }

    // the queue
    public get queue() {
        return this._queue.asObservable();
    }

    // public events
    public onCompleteItem(queueObj: FileQueueObject, response: any): any {
        return { queueObj, response };
    }

    public onErrorItem(queueObj: FileQueueObject, response: any): any {
        return { queueObj, response };
    }

    public onProgressItem(queueObj: FileQueueObject): any {
        return { queueObj };
    }

    public onCancelItem(queueObj: FileQueueObject): any {
        return { queueObj };
    }

    public onDeleteItem(queueObj: FileQueueObject): any {
        return { queueObj };
    }

    public onErrorDeleteItem(queueObj: FileQueueObject, response: any): any {
        return { queueObj, response };
    }

    // public functions
    public addToQueue(data: any) {
        // add file to the queue
        this._addToQueue(data);
        // _.each(data, (file: any) => this._addToQueue(file));
    }

    public clearQueue() {
        // clear the queue
        this._files = [];
        this._queue.next(this._files);
    }

    public downloadAll() {
        // upload all except already successfull or in progress
        _.each(this._files, (queueObj: FileQueueObject) => {
            if (queueObj.isCheckToDownload()) {
                this._download(queueObj);
            }
        });
    }

    // private functions
    private _addToQueue(file: any) {
        const queueObj = new FileQueueObject(file);

        // set the individual object events
        queueObj.download = () => this._download(queueObj);
        queueObj.remove = () => this._removeFromQueue(queueObj);
        queueObj.cancel = () => this._cancel(queueObj);
        queueObj.delete = () => this._delete(queueObj);

        // push to the queue
        this._files.push(queueObj);
        this._queue.next(this._files);
    }

    private _removeFromQueue(queueObj: FileQueueObject) {
        _.remove(this._files, queueObj);
    }



    private _download(queueObj: FileQueueObject) {
        this.req = new HttpRequest('GET', this.PATH_DOWNLOAD + '/' + queueObj.file.HASH, {
            reportProgress: true, responseType: 'blob'
        });
        queueObj.request = this.req;
        queueObj.status = FileQueueStatus.Pending;
        // download file and report progress
        queueObj.request_subscription = this.http.request(this.req).subscribe(
            (event: any) => {
                // if (event.type === HttpEventType.DownloadProgress) {
                //     this._downloadProgress(queueObj, event);
                // } else if (event instanceof HttpResponse) {
                //     this._downloadComplete(queueObj, event);
                // } else if (queueObj.status === FileQueueStatus.Cancel) {
                //      console.log('cancel');
                // }
                if (queueObj.status === FileQueueStatus.Cancel) {
                    // console.log('Estado: Cancelando ');
                } else {
                    if (event.type === HttpEventType.DownloadProgress) {
                        this._downloadProgress(queueObj, event);
                    } else if (event instanceof HttpResponse) {
                        this._downloadComplete(queueObj, event);
                    }
                }
            },
            (err: any) => {
                if (err.error instanceof Error) {
                    // A client-side or network error occurred. Handle it accordingly.
                    this._downloadFailed(queueObj, err);
                } else {
                    // The backend returned an unsuccessful response code.
                    this._downloadFailed(queueObj, err);
                }
            },
            () => {
                if (queueObj.status === FileQueueStatus.Cancel) {
                    // console.log('complete cancelled');
                    queueObj.status = FileQueueStatus.Init;

                } else {
                    // console.log('complete');
                }

            }
        );

        return queueObj;
    }


    private _delete(queueObj: FileQueueObject) {
        // Elimina el fichero de la BD

        queueObj.progress = 100;
        queueObj.status = FileQueueStatus.Pending;
        this._queue.next(this._files);


        // Antes de llamar al delegado guardamos la información del fichero para
        // asociarlo con el fichero físico recien subido


        // aqui enviamos el infofile para add or update , si el infofile viene con ID será update
        this.http.delete(this.PATH_DELETE + '/' + queueObj.file.Id, { observe: 'response' }).subscribe(
            (success: any) => {
                const numero = success.status;
                this.onDeleteItem(queueObj);
            },
            (err: HttpErrorResponse) => {
                queueObj.progress = 0;
                queueObj.status = FileQueueStatus.Error;
                queueObj.response = err;
                this._queue.next(this._files);
                this.onErrorDeleteItem(queueObj, err);
            });


    }


    private _cancel(queueObj: FileQueueObject) {
        queueObj.progress = 0;
        queueObj.status = FileQueueStatus.Cancel;
        this._queue.next(this._files);
        this.onCancelItem(queueObj);
        // queueObj.request_subscription.unsubscribe();
    }

    private _downloadProgress(queueObj: FileQueueObject, event: any) {
        // update the FileQueueObject with the current progress
        const progress = Math.round(100 * event.loaded / event.total);
        queueObj.progress = progress;
        queueObj.status = FileQueueStatus.Progress;
        this._queue.next(this._files);
        this.onProgressItem(queueObj);
    }

    private _downloadComplete(queueObj: FileQueueObject, response: HttpResponse<any>) {
        // update the FileQueueObject as completed
        queueObj.progress = 100;
        queueObj.status = FileQueueStatus.Success;
        queueObj.response = response;
        this._queue.next(this._files);
        this.onCompleteItem(queueObj, response.body);
    }

    private _downloadFailed(queueObj: FileQueueObject, response: HttpErrorResponse) {
        // update the FileQueueObject as errored
        queueObj.progress = 0;
        queueObj.status = FileQueueStatus.Error;
        queueObj.response = response;
        this._queue.next(this._files);
        this.onErrorItem(queueObj, response.error);
    }

}

// https://stackblitz.com/edit/angular-5-file-upload-queue?file=app%2Ffile-uploader.service.ts
